import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from '../locales/en/translation.json';
import taTranslation from '../locales/ta/translation.json';
import hiTranslation from '../locales/hi/translation.json';



i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'ta', 'hi'],
    resources: {
      en: {
        translation: enTranslation,
      },
      ta: {
        translation: taTranslation,
      },
      hi: {
        translation: hiTranslation,
      },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
